import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from './url_helper';
import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_ESTABLISHMENT_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Period
export const getPeriodList = params =>
	apiClient.get(`${url.GET_PERIODS}?${stringifyParams(params)}`);
export const getPeriodQuery = params =>
	apiClient.get(
		url.GET_PERIOD_QUERY + (params ? `?${stringifyParams(params)}` : '')
	);
export const getPeriodById = id => apiClient.get(url.GET_PERIOD_BY_ID + id);
export const updatePeriod = period =>
	apiClient.put(url.PUT_PERIOD + period._id, period);
export const deletePeriod = period =>
	apiClient.delete(url.DELETE_PERIOD + period._id);
